import GameOptions from '../config';
import DayCycle from '../components/DayCycle';
import Dialog from '../components/Dialog';

import IMGMountainBack from '../../images/mountains-back.png';
import IMGMountainMid from '../../images/mountains-mid1.png';
import IMGCloud from '../../images/cloud.png';
import IMGMountainFront from '../../images/mountains-mid2.png';
import IMGRoad from '../../images/road.png';
import IMGHoues from '../../images/houses.png';
import IMGSun from '../../images/sun.png';
import IMGMoon from '../../images/moon.png';
import IMGRain from '../../images/rain.png';

class GameScene extends Phaser.Scene{
    constructor(){
        super({
        	key: "GameScene"
        });

        this.mountainsBack = null;
        this.mountainsMid = null;
        this.mountainsFront = null;
        this.road = null;
        this.houses = null;
        this.isRaining = false;
        this.lightningTimer = null;
        this.clouds = [];
    }

    preload(){
	    this.load.image('mountains-back', IMGMountainBack);
	    this.load.image('mountains-mid', IMGMountainMid);
	    this.load.image('cloud', IMGCloud);
	    this.load.image('mountains-front', IMGMountainFront);
	    this.load.image('road', IMGRoad);
	    this.load.image('houses', IMGHoues);
	    this.load.image('sun', IMGSun);
	    this.load.image('moon', IMGMoon);

	   	this.load.spritesheet('rain', IMGRain, { frameWidth: 17, frameHeight: 17 });

	   	//this.setTimedBackground();
    }

    create(){
    	this.createScenery();
	    this.createClouds();
	    this.createDayCycle();
	    //404 message
	    this.createMessage();
	    this.createEvents();
	    this.keybindings();
    }

    createEvents(){
    	this.storm();
    }

    setTimedBackground(){
    	var today = new Date();
		var time = today.getHours();

		if(time <= 6 || time >= 20)
			this.setBackground(GameOptions.background.sky.night);
		else
			this.setBackground(GameOptions.background.sky.day);

    }

	setBackground(color){
		this.cameras.main.setBackgroundColor(color);
	}

	storm(){
    	this.eventStorm = this.time.addEvent({
    		delay: Phaser.Math.Between(10000,30000),
    		callback: () => {
				this.isRaining = !this.isRaining;
				this.toggleWeather();
				this.storm();
    		},
    		callbackScope: this,
    		repeat: 0
    	});
	}

 	lightning(){

    	if(this.lightningTimer !== null){
	 		//Duration, R, G, B, force
		    this.cameras.main.flash(500, 255, 255, 255);
		    //Duration, intensity, force
		    this.cameras.main.shake(500, 0.005);
		}

    	this.lightningTimer = this.time.addEvent({
    		delay: Phaser.Math.Between(5000,20000),
    		callback: this.lightning,
    		callbackScope: this,
    		repeat: 0
    	});

	}

    createMessage(){
	    const dialog = {
	    	x: 50,
	    	y: 100,
	    	width: this.cameras.main.displayWidth - 100,
	    	height: 300,
	    	padding: 25,
	    	title: GameOptions.title,
	    	subTitle: GameOptions.subTitle
	    };

    	this.dialog = new Dialog(this, dialog);
    }

    createDayCycle(){
    	this.dayCycle = new DayCycle(this, 60000);

    	const backgroundSpriteDay = new Phaser.Display.Color.HexStringToColor(GameOptions.background.sky.day);
    	const backgroundSpriteNight = new Phaser.Display.Color.HexStringToColor(GameOptions.background.sky.night);
    	const mountainsBackColor = new Phaser.Display.Color(149, 206, 188);
    	const mountainsMidColor = new Phaser.Display.Color(139, 189, 172);
    	const mountainsFrontColor = new Phaser.Display.Color(129, 172, 157);

        let backgroundSprites = [
            {sprite: this.backgroundSprite, from: backgroundSpriteNight, to: backgroundSpriteDay },
            {sprite: this.mountainsBack, from: mountainsBackColor.clone().darken(80), to: mountainsBackColor },
            {sprite: this.mountainsMid, from: mountainsMidColor.clone().darken(60), to: mountainsMidColor },
            {sprite: this.mountainsFront, from: mountainsFrontColor.clone().darken(40), to: mountainsFrontColor }
        ];

        this.dayCycle.initShading(backgroundSprites);
        this.dayCycle.initSun(this.sunSprite);
        this.dayCycle.initMoon(this.moonSprite);
    }

    keybindings(){
    	var s = this.input.keyboard.addKey('S');
		s.on('up', (event) => { 
			this.isRaining = !this.isRaining;
			this.toggleWeather();
		});
    }

    createScenery(){

    	const height = this.cameras.main.displayHeight;
    	const width = this.cameras.main.displayWidth;

		this.backgroundSpriteTexture = this.textures.createCanvas("background-daycyle", width, height);

        this.backgroundSpriteTexture.context.rect(0, 0, width, height);
        this.backgroundSpriteTexture.context.fillStyle = '#b2ddc8';
        this.backgroundSpriteTexture.context.fill();
        this.backgroundSpriteTexture.refresh();

        this.backgroundSprite = this.add.image(0, 0, "background-daycyle").setOrigin(0,0);

        this.sunSprite = this.add.sprite(50, -250, 'sun');
        this.moonSprite = this.add.sprite(width - (width / 4), height + 500, 'moon');
    	//Set X / Y / Width / Height (W / H default to texture size if 0)
    	//Set origin to Bottom Left?
	    this.mountainsBack = this.add.tileSprite(
	    	0,
	        height,
	        0,
	        0,
	        'mountains-back'
	    ).setOrigin(0, 1);

	    this.mountainsMid = this.add.tileSprite(
	    	0,
	        height,
	        0,
	        0,
	        'mountains-mid'
	    ).setOrigin(0, 1);

	    this.mountainsFront = this.add.tileSprite(
	    	0,
	        height,
	        0,
	        0,
	        'mountains-front'
	    ).setOrigin(0, 1);

	    // this.road = this.add.tileSprite(
	    // 	0,
	    //     height,
	    //     0,
	    //     0,
	    //     'road'
	    // ).setOrigin(0, 1);

	    // this.houses = this.add.tileSprite(
	    // 	0,
	    //     height - 43,
	    //     0,
	    //     0,
	    //     'houses'
	    // ).setOrigin(0, 1);
    }

    createClouds(){
    	var cloudCount = Phaser.Math.Between(GameOptions.background.clouds.count.min, GameOptions.background.clouds.count.max);

	    for (var i = 0; i <= cloudCount; i++) {
	    	var opacity = Phaser.Math.Between(GameOptions.background.clouds.opacity.min, GameOptions.background.clouds.opacity.max);
	    	var height = this.cameras.main.displayHeight;
	    	var width = this.cameras.main.displayWidth;
	    	var randY = Phaser.Math.Between(0, height/2);
	    	var randX = Phaser.Math.Between(0, width);

    		var cloudSpeed = Phaser.Math.Between(GameOptions.background.clouds.speed.min, GameOptions.background.clouds.speed.max) / 100;
	    	var cloud = this.add.image(randX, randY, 'cloud' ).setOrigin(0, 1);
		    cloud.alpha = (opacity / 100);

		    //Create rain emitter
    		var particles = this.add.particles('rain');

		    var rain = {
		        width: 17,
		        height: 5,
		        getPoints: function (quantity)
		        {
		            var cols = (new Array(rain.width)).fill(0);
		            var lastCol = cols.length - 1;
		            var Between = Phaser.Math.Between;
		            var RND = Phaser.Math.RND;
		            var points = [];

		            for (var i = 0; i < quantity; i++)
		            {
		                var col = Between(0, lastCol);
		                var row = (cols[col] += 1);

		                if (RND.frac() < 0.01)
		                {
		                    row *= RND.frac();
		                }

		                row %= rain.height;
		                row |= 0;

		                points[i] = new Phaser.Math.Vector2(16 * col, 16 * row);
		            }

		            return points;
		        }
		    };

		    var emitter = particles.createEmitter({
		        speedY: { min: GameOptions.background.rain.speed.min , max: GameOptions.background.rain.speed.max },
		        scale: { min: GameOptions.background.rain.scale.min , max: GameOptions.background.rain.scale.max },
		        gravityY: GameOptions.background.rain.gravityY,
		        lifespan: 3000,
		        blendMode: 'ADD',
		        follow: cloud,
		        followOffset: {
			    	x: 0,
			    	y: -(cloud.displayHeight / 2)
			    },
			    emitZone: { type: 'edge', source: rain, quantity: 100 },
		        on: false
		    });


		    this.clouds.push({
		    	object: cloud,
		    	emitter: emitter,
		    	speed: cloudSpeed
		    });
	    }
    }

    toggleWeather(){	
    	//Set up rain emitters	    	
    	for (var i = this.clouds.length - 1; i >= 0; i--) {
    		var cloud = this.clouds[i];
    		if(!this.isRaining){
    			cloud.emitter.stop();
    		}
    		else{
		    	cloud.emitter.start();
    		}
    	}

    	//Handle everything else
    	if(!this.isRaining){
			//this.setTimedBackground();
			this.lightningTimer.remove();
			this.lightningTimer = null;
		}
		else{
	    	//this.setBackground(GameOptions.background.sky.stormy);
			this.lightning();
		}
    }

    update(){
    	this.updateMountains();
    	this.updateClouds();
    }

    updateMountains(){
	    this.mountainsBack.tilePositionX += GameOptions.background.mountains.back;
	    this.mountainsMid.tilePositionX += GameOptions.background.mountains.mid;
	    this.mountainsFront.tilePositionX += GameOptions.background.mountains.front; 
	    //this.road.tilePositionX += GameOptions.background.road; 
	    //this.houses.tilePositionX += GameOptions.background.houses; 
    }

    updateClouds(){
    	for (var i = this.clouds.length - 1; i >= 0; i--) {
    		var cloud = this.clouds[i];
	    	var width = this.cameras.main.displayWidth;
    		cloud.object.x -= cloud.speed;

    		//If cloud is completely off screen reset to loop..
    		if(cloud.object.x < -cloud.object.displayWidth){
    			cloud.object.x = width;
    		}
    	}
    }
}

export default GameScene;